var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackToListSolid = function SvgBackToListSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47581 22 2 17.5242 2 12C2 6.47581 6.47581 2 12 2C17.5242 2 22 6.47581 22 12C22 17.5242 17.5242 22 12 22ZM16.6774 10.2258H12V7.36694C12 6.93548 11.4758 6.71774 11.1734 7.02419L6.56452 11.6573C6.375 11.8468 6.375 12.1492 6.56452 12.3387L11.1734 16.9718C11.4798 17.2782 12 17.0605 12 16.629V13.7742H16.6774C16.9435 13.7742 17.1613 13.5565 17.1613 13.2903V10.7097C17.1613 10.4435 16.9435 10.2258 16.6774 10.2258Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackToListSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back_to_list_solid.a896770c.svg";
export { ForwardRef as ReactComponent };